import "../../../styles/index.css"
import "./MenuFiltros.css"
import CloseMenuFiltros from "../../../assets/icons/Close Button.svg"
import Slider from "@mui/material/Slider"
import AccordionFiltros from "../../Accordions/AccordionFiltros/AccordionFiltros"
import { useState, useRef, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import CustomButton from "../../Buttons/CustomButton/CustomButton"
import $ from "jquery"

function MenuFiltros({ titulos, filtros, filterKeys }) {
	const [searchParams, setSearchParams] = useSearchParams()
	const filterMinValue = useRef(Number(searchParams.get("min")) || 0)
	const filterMaxValue = useRef(Number(searchParams.get("max")) || 15000)
	const [sliderValue, setSliderValue] = useState([
		filterMinValue.current,
		filterMaxValue.current,
	])

	const [filtrosSelecionados, setFiltrosSelecionados] = useState({})

	useEffect(() => {

        const menuAtual = document.querySelector('.menuFiltros')

        menuAtual.addEventListener('show.bs.collapse', (event) => {
			$('<div class="overlay"></div>').appendTo(document.body);
			$('body').css('overflow', 'hidden')
        })

    }, [])

	useEffect(() => {
		if (filterKeys) {
			const filtrosSelecionadosAux = filtrosSelecionados

			filterKeys.forEach((key) => {
				filtrosSelecionadosAux[key] = searchParams.getAll(key)
			})

			setFiltrosSelecionados({ ...filtrosSelecionadosAux })
		}
	}, [filterKeys, searchParams])

	const onClickFiltros = () => {
		console.log("Filtros selecionados: ", filtrosSelecionados)
		const copia = { ...filtrosSelecionados }
		copia["min"] = sliderValue[0]
		copia["max"] = sliderValue[1]
		setSearchParams(copia)
		removeOverlay()
	}

	const onClickFiltrosResetar = () => {
		setSearchParams({})
		setSliderValue([0, 15000])
		removeOverlay()
	}

	const sliderChange = (event, newValue, activeThumb) => {
		const minDistance = 500

		if (!Array.isArray(newValue)) {
			return
		}

		if (activeThumb === 0) {
			setSliderValue([
				Math.min(newValue[0], sliderValue[1] - minDistance),
				sliderValue[1],
			])
		} else {
			setSliderValue([
				sliderValue[0],
				Math.max(newValue[1], sliderValue[0] + minDistance),
			])
		}
	}

	const removeOverlay = () => {
        $('.overlay').remove()
		$('body').css('overflow', 'auto')
    }

	return (
		<div
			className="menuFiltros collapse collapse-horizontal"
			id="menuFiltros"
		>
			<button
				className="botaoFecharMenuFiltros"
				data-bs-toggle="collapse"
				data-bs-target="#menuFiltros"
				aria-expanded="false"
				onClick={removeOverlay}
			>
				<img src={CloseMenuFiltros} alt="Fechar Menu Lateral" />
			</button>

			<h5>Filtros</h5>

			<section className="sectionRangePreço">
				<p className="s1 negrito">Preço</p>

				<div className="divRangePreço">
					<input
						readOnly
						type="text"
						className="c1 inputRangePreço text-center"
						id="priceMin"
						value={`R$ ${sliderValue[0]},00`}
					/>

					<input
						readOnly
						type="text"
						className="c1 inputRangePreço text-center"
						id="priceMax"
						value={`R$ ${sliderValue[1]},00`}
					/>

					<Slider
						getAriaLabel={() => "Range de Preço"}
						value={sliderValue}
						onChange={sliderChange}
						min={0}
						max={15000}
						color="error"
						disableSwap
					/>
				</div>
			</section>

			<section className="sectionMultiplosFiltros">

				{
					filtros && titulos && filterKeys && filtros.map((filtro, index) => (
						<AccordionFiltros
							key={index}
							titulo={titulos[index]}
							arrayProps={filtro}
							filterKey={filterKeys[index]}
							filtrosSelecionados={filtrosSelecionados}
						/>
					))
				}

			</section>

			<section className="sectionBotoesMenuFiltros">

				<div data-bs-toggle="collapse" data-bs-target="#menuFiltros">
					<CustomButton
						texto="Aplicar"
						cor={"#A80A01"}
						tipo='3'
						onClick={onClickFiltros}
					/>
				</div>

				<div data-bs-toggle="collapse" data-bs-target="#menuFiltros">
					<CustomButton
						texto="Redefinir"
						cor={"white"}
						tipo='3'
						onClick={onClickFiltrosResetar}
					/>
				</div>

			</section>


		</div>
	)
}

export default MenuFiltros
